import { useRecoilValue } from 'recoil';

import { TableContextProvider } from 'lib/context/TableContext/TableContextProvider';

import { currentPractice } from 'components/practice/practiceState';
import AGTable from 'components/shared/AGTable/AGTable';

import { getColDefs } from '../lib/resultsHelper';

const ResultsList = ({ itemProps, setActiveView }) => {
  const practice = useRecoilValue(currentPractice);

  const clickHandler = (e) => {
    setActiveView((prev) => {
      return {
        ...prev,
        type: 'results',
        data: { ...prev?.data, result: e.data },
        component: 'preview'
      };
    });
  };

  return (
    <TableContextProvider cols={getColDefs(practice?.timezone)} name="results_table">
      <AGTable
        data={itemProps?.labOrderResults}
        onRowClicked={clickHandler}
        rowClass="cursor-pointer"
      />
    </TableContextProvider>
  );
};

export default ResultsList;
